var IMPORT_PREFIX_PATTERN = /^@import/i;

function isImport(value) {
  return IMPORT_PREFIX_PATTERN.test(value);
}

module.exports = isImport;



//////////////////
// WEBPACK FOOTER
// ./~/clean-css/lib/utils/is-import.js
// module id = 883
// module chunks = 16